export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4786.5f12aeb5.jpg";